
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/analytics'

import { useAuthState } from 'react-firebase-hooks/auth'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { useState, useRef } from 'react'

import './App.css'

firebase.initializeApp({
  apiKey: "AIzaSyDeBdxjx3s_D_7bZeeukyt7Svu3ZFsFuRQ",
  authDomain: "react-chat-app-e7cba.firebaseapp.com",
  projectId: "react-chat-app-e7cba",
  storageBucket: "react-chat-app-e7cba.appspot.com",
  messagingSenderId: "677748663492",
  appId: "1:677748663492:web:91b2fead6e11a28af45591",
  measurementId: "G-B8J1YNQS2D"
})


const auth = firebase.auth();
const firestore = firebase.firestore();
const analytics = firebase.analytics();

function App() {
  const [user] = useAuthState(auth)
  return (
    <div className="App">
      <header>
      <h1>⚛️🔥💬</h1>
        <SignOut />
      </header>
      <section>
        {user ? <ChatRoom /> : <SignIn />}
      </section>
    </div>
  );
}

function SignIn() {
  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider()
    auth.signInWithPopup(provider)
  }
  return (
    <button onClick={signInWithGoogle}>
      Sign in with Google
    </button>
  )
}
function SignOut() {
  return auth.currentUser && (
    <button onClick={() => auth.signOut()}>Sign Out</button>
  )
}
function ChatRoom() {
  const dummy = useRef()
  const messagesRef = firestore.collection('messages')
  console.log(messagesRef)
  const query = messagesRef.orderBy('createdAt').limit(25)
   
  const [messages] = useCollectionData(query, { idField: 'id' })
  console.log(messages)
  const [formValue, setFormValue] = useState('')

  const sendMessage = async e => {
    e.preventDefault()
    const { uid, photoURL } = auth.currentUser

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL
    })

    setFormValue('')

    dummy.current.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <>
      <div>
        {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} />)}
        <div ref={dummy}></div>
      </div>
      <form onSubmit={sendMessage}>
        <input value={formValue} 
        onChange={e => setFormValue(e.target.value)}
        placeholder="say something nice" 
        />
        <button type="submit" disabled={!formValue}>
        🕊️
      </button>
      </form>
    </>
  )
}

function ChatMessage(props) {
  const { text, uid, photoURL, id, createdAt } = props.message
  //console.log(props.message)
  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received'
  const handleOnClick = (id) => {
    firestore.collection('messages').doc(id).delete()
    .then(()=>{console.log("successfully deleted! ")})
    .catch((error)=>{ console.log("Error removing document:", error)})
  }
  return (<>
    <div className={`message ${messageClass}`}>
      <img onClick={() => handleOnClick(id)} src={photoURL || 'https://api.adorable.io/avatars/23/abott@adorable.png'} alt="" />
      <p>{text}</p>
    </div>
  </>
  )
}

export default App;
